export const listConstant = {
  childHeader: 'Process Audit list',
  addButtonLable: 'New Plan',
  datePickerLabel: 'Search By Year',
  modalTile: 'CREATE NEW PLAN',
};

export const createConstant = {
  childHeader: 'PROCESS AUDIT PLAN list',
  theadHeader: 'PROCESS AUDIT PLAN',
  extracolSpan: 1,
};

export const apiConstant = {
  // list api url
  gettableListDataurl: 'processAuditPlanRoute/monthlylist',
  deleteListurl: 'processAuditPlanRoute',
  getListPlanByid: 'processAuditPlanRoute',
  createListPlanByid: 'processAuditPlanRoute',

  // -----plan--
  sync: 'processAuditPlanRoute/handleSync',
  getAllPlanById: 'processAuditPlanRoute/allplansbyid',
  upadateCreateAllPlan: 'processAuditPlanRoute/allplansCreateUpdate',
  maintenancePlanDeleteBulkById:
    'processAuditPlanRoute/maintenancePlanDeleteBulkById',
};

export const tilesConstant = {
  childHeaderText: 'PROCESS AUDIT PLAN',
};

export const navigationConstant = {
  planRouter: '/common/processAuditPlan_PlanCreate',
};
